// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__8owQY","tabStyles":"List_tabStyles__yqOn3","dateSwitch":"List_dateSwitch__S618D"};